var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.misc && _vm.misc.logos_image)?_c('section',{staticClass:"accreditations"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.misc.logos_image,"alt":"Find us on these popular sites"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }